import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useSpring } from 'react-spring';
import { useWindowSize } from 'usehooks-ts';
import { AppProvider } from '../../App';
import AfterLoggedIn from '../../components/login/AfterLoggedIn';
import Navbar from '../../components/navbar/Navbar';
import TopBanner from '../../components/TopBanner/TopBanner';
import { useGlobalState } from '../../state/GlobalStateProvider';
import Bench from '../Bench/Bench';
import BenchProvider from '../Bench/BenchProvider';
import Chain from '../Chain/Chain';
import ChainReputation from '../ChainReputation/ChainReputation';
import ContractsTable from '../Contracts/Contracts';
import Identity from '../Identity/Identity';
import MobileView from '../Mobile/MobileView';
import Onboarding from '../Onboarding/Onboarding';
import Project from '../Project/Project';
import ProjectReputation from '../ProjectReputation/ProjectReputation';
import Review from '../Reviews/Review';
import UserReview from '../Reviews/UserReviews';
import './Mrep.scss';
import TwitterCallback from './TwitterCallback';

function HomeRedirect() {
  const [{ user }] = useGlobalState();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if the user is logged in and at the base URL.
    if (user && location.pathname === '/') {
      navigate(`/takes`);
    }
  }, [user, location.pathname, navigate]);

  return null;
}

function InvalidRouteRedirect() {
  const [{ user }] = useGlobalState();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(`/profile/${user.address}/projects`);
    } else {
      navigate('/');
    }
  }, [user, navigate]);

  return null;
}

const MrepComponents = () => {
  const [{ user, setUser, tempUser }] = useGlobalState();
  const history = useNavigate();
  const [onboarding, setOnboarding] = useState(true);
  const { width } = useWindowSize();

  const pageAnimation = useSpring({
    from: { transform: 'translateX(80%)', opacity: 0 },
    to: { transform: 'translateX(0)', opacity: 1 },
    config: { tension: 200, friction: 30 },
    width: '100%',
    height: '100%',
  });

  function handleOnboarding(user) {
    setUser(user);
    setOnboarding(false);
    history('/takes');
  }
  useEffect(() => {
    if (user) {
      setOnboarding(user?.isFirstLogin || !user?.avatarUrl);
    }
  }, [user]);

  return (
    <div className='app_wrapper'>
      {onboarding ? (
        <Onboarding handleOnboarding={handleOnboarding} />
      ) : (
        <>
          {width > 600 ? (
            <>
              <TopBanner />
              <Navbar />
              <div className='mrep_container'>
                <Routes>
                  <Route element={<AppProvider />}>
                    <Route path='/' element={<HomeRedirect />} />
                    <Route path='/pod' element={<Identity />} />
                    {/* <Route path='/eligibility' element={<EligibiltyWrapper />} /> */}
                    <Route path='/takes' element={<Review />} />
                    <Route path='/takes/:project' element={<Review />} />
                    <Route path='/takes/twittertakes' element={<Review tab={1}  />} />
                    <Route path='/twitterCallback' element={<TwitterCallback />} />
                    <Route path='/profile' element={<BenchProvider />}>
                      <Route path='/profile' element={<Bench />} />
                      <Route path='/profile/:userAddress/projects' element={<ProjectReputation pageAnimation={pageAnimation} />} />
                      <Route path='/profile/:userAddress/chains' element={<ChainReputation pageAnimation={pageAnimation} />} />
                      <Route path='/profile/:userAddress/takes' element={<UserReview />} />
                      {/* <Route path='/bench/:userAddress/peers' element={<Peer pageAnimation={pageAnimation} />} /> */}
                      <Route path='/profile/:userAddress/chains/:chainId' element={<Chain />} />
                      <Route path='/profile/:userAddress/projects/:projectName' element={<Project />} />
                    </Route>
                    {/* <Route path='/explore' element={<Rewards />} /> */}
                    {/* <Route path='/test' element={<Test />} /> */}

                    <Route path='*' element={<InvalidRouteRedirect />} />
                  </Route>
                  <Route path='/contracts/:platform' element={<ContractsTable />} />
                  {/* <Route path='/test' element={} /> */}
                </Routes>

                {/* <a className='pointer' href='https://docs.google.com/forms/d/e/1FAIpQLSe7rI9SGuvZOrVkNhK4skKBuev2HJvXtaRr0mEUNOrwjnrkxg/viewform' target='_blank'>
              <BlueBadge text={'REQUEST A PROJECT'} />
            </a> */}
              </div>
            </>
          ) : (
            <MobileView />
          )}
        </>
      )}
    </div>
  );
};

const Mrep = () => {
  return (
    <AfterLoggedIn>
      <MrepComponents />
    </AfterLoggedIn>
  );
};

export default Mrep;
